import React from 'react'

const CancelPaymentComponents = () => {
    return (
        <div><div class="cancel-container">
            <div class="icon-fail">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>

            <h1>Payment Canceled</h1>
            <p>We couldn’t complete your payment. Please verify your details and try again.</p>
            <a href="/pricing" class="btn">Try Again</a>
        </div></div>
    )
}

export default CancelPaymentComponents